/** 
Classification Experiment

TLDR: An Onboarding modal with survey-type questions capturing information about
the user to be used for classification, such as their investing skill level.

Includes additional slides that appear after the classifications, depending on the flow being run at the time. Argument `flowId` determines the flow being run.

https://run.userpilot.io/flows
*/

type Fields = {
  onboarding_experience_level?: 'beginner' | 'intermediate' | 'advanced';
  onboarding_stocks_in_portfolio?: 'none' | '1-5' | '6-20' | '20+';
};

const saveData = async (saveResponses: (fields: Fields) => Promise<any>) => {
  try {
    const fields = {};
    const onboarding_experience_level = window.sessionStorage.getItem(
      'onboarding_experience_level'
    );
    const onboarding_stocks_in_portfolio = window.sessionStorage.getItem(
      'onboarding_stocks_in_portfolio'
    );
    if (onboarding_experience_level) {
      fields['onboarding_experience_level'] = onboarding_experience_level;
    }
    if (onboarding_stocks_in_portfolio) {
      fields['onboarding_stocks_in_portfolio'] = onboarding_stocks_in_portfolio;
    }
    if (Object.keys(fields).length === 0) {
      return;
    }
    console.log('Userpilot: classification - save data', { fields });
    await saveResponses(fields);
    sessionStorage.removeItem('onboarding_experience_level');
    sessionStorage.removeItem('onboarding_stocks_in_portfolio');
  } catch (error) {
    console.error(
      'Userpilot:classification - save data - unable to select values',
      {
        error,
      }
    );
  }
};

type Args = {
  userId: string;
  onComplete: () => unknown;
  saveResponses: (fields: Fields) => Promise<any>;
  userpilot: NonNullable<Window['userpilot']>;
  trackEvent: (eventName: string, data: any) => void;
  flowId: string;
};

export const runClassificationExperiment = ({
  userId,
  onComplete,
  saveResponses,
  userpilot,
  trackEvent,
  flowId,
}: Args) => {
  console.log('Userpilot: classification - run');
  userpilot.once('completed', ({ token, ...eventData }) => {
    trackEvent('completed', eventData);
    saveData(saveResponses);
    onComplete();
  });
  userpilot.once('dismissed', ({ token, ...eventData }) => {
    trackEvent('dismissed', eventData);
    saveData(saveResponses);
    onComplete();
  });
  console.log('Userpilot: classification - identify', { userId });
  userpilot.identify(userId);
  console.log('Userpilot: classification - trigger');
  userpilot.trigger(flowId);
};
